export const LENS_INTELLIGENCE_FEATURE = 'lens_intelligence';

/** Default workspace/project lens features when none are configured yet. */
export const DEFAULT_WORKSPACE_LENS_FEATURES = [
    'project_overview',
    'dataroom',
    'information_requests',
    'observations',
    'journal',
    'the_tent',
    'project_management',
    'raid_log',
    'action_log',
    LENS_INTELLIGENCE_FEATURE,
];

/** Default-on project features when the key is absent from stored enabled_features. */
export const DEFAULT_PROJECT_ENABLED_FEATURES = {
    project_overview: true,
    dataroom: true,
    information_requests: true,
    observations: true,
    journal: true,
    the_tent: true,
    [LENS_INTELLIGENCE_FEATURE]: true,
    project_management: true,
    raid_log: true,
    action_log: true,
};

/**
 * Normalize stored enabled_features for UI and client checks.
 * Missing default-on keys (e.g. lens_intelligence on older projects) resolve to true.
 */
export function normalizeProjectEnabledFeatures(source = {}, allFeatureKeys = []) {
    const normalized = {};
    allFeatureKeys.forEach(key => {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            normalized[key] = !!source[key];
        } else if (Object.prototype.hasOwnProperty.call(DEFAULT_PROJECT_ENABLED_FEATURES, key)) {
            normalized[key] = DEFAULT_PROJECT_ENABLED_FEATURES[key];
        } else {
            normalized[key] = false;
        }
    });
    return normalized;
}

/**
 * Whether a project feature is enabled.
 * Missing enabled_features (legacy projects) keeps features visible.
 */
export function isProjectFeatureEnabled(enabledFeatures, featureKey) {
    if (!enabledFeatures) return true;
    if (Object.prototype.hasOwnProperty.call(enabledFeatures, featureKey)) {
        return enabledFeatures[featureKey] !== false;
    }
    if (Object.prototype.hasOwnProperty.call(DEFAULT_PROJECT_ENABLED_FEATURES, featureKey)) {
        return DEFAULT_PROJECT_ENABLED_FEATURES[featureKey] !== false;
    }
    return false;
}

export function isLensIntelligenceEnabled(project) {
    return isProjectFeatureEnabled(project?.enabled_features, LENS_INTELLIGENCE_FEATURE);
}

/** Merge required features with saved or default workspace lens features. */
export function resolveWorkspaceLensFeatures(savedFeatures, requiredFeatures) {
    const saved = Array.isArray(savedFeatures) ? savedFeatures : [];
    const base = saved.length ? saved : DEFAULT_WORKSPACE_LENS_FEATURES;
    return Array.from(new Set([...(requiredFeatures || []), ...base]));
}
